export { isNotFound } from './is-not-found'
